import type {FilterModel} from 'services/settings/types';

// Converts any date objects to string, so it can be serialized and stored in redux.
export const normalizeFilterModel = (filterModel: FilterModel): FilterModel => {
  return {
    ...filterModel,
    items: filterModel.items.map(item => ({
      ...item,
      value: isDate(item.value) ? item.value.toString() : item.value,
    })),
  };
};

const isDate = (val: unknown): boolean => {
  return Object.prototype.toString.call(val) === '[object Date]';
};
